module.exports = __webpack_public_path__ + "static/media/Title.a6c8eb78.svg";